const ContactEmail = () => (
  <a className="text-blue-700 hover:underline" href="mailto:contact@daisho.ml">
    contact@daisho.ml
  </a>
);

export default ContactEmail;
